module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-Medium.3e96fbe9.ttf";